import { ClockCard } from "./components/ClockCard";
import { HeroCard } from "./components/HeroCard";
import styles from "./OverviewPage.module.css";

import { useCurrentUser } from "@/hooks/useCurrentUser";

/**
 * Overview — the dashboard landing page and the reference implementation for
 * what a feature looks like: a page component composed from feature-local
 * components, importing only shared layers. Copy a feature folder like this one
 * to start a new feature (see docs/CONTRIBUTING.md).
 */
export function OverviewPage() {
  const { status, user, permissions } = useCurrentUser();
  const name = user?.name?.trim() || user?.username?.trim() || "there";
  const title = status === "loading" ? "Welcome back." : `Welcome back, ${name}.`;

  // A user whose only capability is seeing this page (e.g. the Non-Member
  // role) gets a message instead of the workspace — permission-derived, not a
  // role-string check.
  const limitedAccess =
    status === "ready" && permissions.every((p) => p === "feature.overview.access");

  if (limitedAccess) {
    return (
      <div className={styles.page}>
        <div className={styles.grid}>
          <HeroCard
            eyebrow="Home"
            title={title}
            description="Your account doesn't have access to any features yet. An administrator needs to assign you a role or grant you access — contact your team admin to get set up."
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.grid}>
        <HeroCard
          eyebrow="Home"
          title={title}
          description="Your workspace is ready. Jump into tools and keep the account flow moving without leaving the dashboard."
        />
        <ClockCard />
      </div>
    </div>
  );
}
